// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"bec68082","251":"30a5d6b2","275":"0772dedf","960":"e9ec7a65"}[chunkId] + ".chunk.js";
};